import { render, staticRenderFns } from "./CodeEdit.vue?vue&type=template&id=49146fa4&scoped=true&"
import script from "./CodeEdit.vue?vue&type=script&lang=js&"
export * from "./CodeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49146fa4",
  null
  
)

export default component.exports